export const CHART_X_UNIT = {
    MONTH: 'month',
    DAY: 'day',
} as const;
export default CHART_X_UNIT;
